import { useRef, useEffect } from "react";
import { createPortal } from "react-dom";

export default function usePortal(children: React.ReactNode, key?: string) {
  const elRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (!elRef.current) {
      const el = document.createElement("div");
      document.body.appendChild(el);
      elRef.current = el;
    }
    return () => {
      if (elRef.current && elRef.current.parentNode) {
        elRef.current.parentNode.removeChild(elRef.current);
      }
    };
  }, []);
  if (elRef.current) {
    return createPortal(children, elRef.current, key);
  }
  return null;
}
